import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { Reveal } from "@/components/Reveal";

const TikTokIcon = ({ size = 30 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className="fill-current">
    <path d="M16.6 5.82a4.28 4.28 0 0 1-1.06-2.82h-3.3v12.93a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 1 1 .73-5.07v-3.36a5.93 5.93 0 0 0-.73-.05A5.95 5.95 0 1 0 15.6 15.9V9.4a7.57 7.57 0 0 0 4.4 1.4V7.5a4.28 4.28 0 0 1-3.4-1.68z" />
  </svg>
);

export const SocialSection = () => {
  const settings = useSettings();

  const socials = [
    { name: "Instagram", handle: "@klusbedrijfpruijn", url: settings.instagram, Icon: Instagram, color: "#E1306C" },
    { name: "Facebook", handle: "Klusbedrijf Pruijn", url: settings.facebook, Icon: Facebook, color: "#1877F2" },
    { name: "TikTok", handle: "@klusbedrijfpruijn", url: settings.tiktok, Icon: TikTokIcon, color: "#ffffff" },
  ].filter((s) => s.url);

  return (
    <section data-testid="social-section" className="py-24 md:py-32 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl mb-14">
          <span className="text-[#FF1A1A] text-sm font-semibold tracking-[0.25em] uppercase">
            Social media
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mt-5 leading-tight">
            Volg ons werk.
          </h2>
          <p className="text-white/60 mt-5 font-light leading-relaxed">
            Blijf op de hoogte van onze laatste projecten en updates. Volg ons op
            social media.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {socials.map(({ name, handle, url, Icon, color }, i) => (
            <Reveal key={name} delay={i * 0.1}>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-link-${name.toLowerCase()}`}
                className="group relative block bg-[#111111] border border-white/10 p-8 hover:border-white/25 transition-all duration-300 hover:-translate-y-1 overflow-hidden"
              >
                <div
                  className="absolute -right-10 -top-10 w-32 h-32 rounded-full blur-2xl opacity-0 group-hover:opacity-30 transition-opacity duration-500"
                  style={{ backgroundColor: color }}
                />
                <div className="relative flex items-center justify-between">
                  <span
                    className="w-14 h-14 flex items-center justify-center border border-white/15 text-white group-hover:scale-110 transition-transform duration-300"
                    style={{ color }}
                  >
                    <Icon size={28} />
                  </span>
                  <ArrowUpRight className="text-white/30 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" size={26} />
                </div>
                <h3 className="font-heading text-xl font-semibold text-white mt-6">{name}</h3>
                <p className="text-white/50 text-sm mt-1">{handle}</p>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialSection;
